import React from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

export interface BackgroundImageProps {
  src: string;
  height: string;
  width?: string;
  borderRadius?:string;
  resizeMode?: 'cover' | 'contain';
  className?: string;
  backgroundPosition?:string;
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({
  resizeMode,
  className,
  borderRadius,
  backgroundPosition,
  ...others
}) => {
  const classes = useStyles({ resizeMode,backgroundPosition,borderRadius, ...others });
  return <div className={clsx(classes.box, className)} {...others} />;
};

const useStyles = createUseStyles({
  box: {
    width: (props: BackgroundImageProps) => props.width || '100%',
    borderRadius: (props: BackgroundImageProps) => props.borderRadius || '0px',
    height: (props: BackgroundImageProps) => props.height || '100%',
    backgroundImage: (props: BackgroundImageProps) => `url(${props.src})`,
    backgroundPosition:(props: BackgroundImageProps)=>props.backgroundPosition ||'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: (props: BackgroundImageProps) =>
      props.resizeMode || 'contain',
  },
});

export default BackgroundImage;
